import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class CoverageGroupCompanyService {
  constructor(client) {
    this.client = client;
  }

  async findAll({ companyIds, policyId, groupCompanyId, page, size }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/coverage-group-companies`,
      {
        params: {
          companyIds,
          policyId,
          groupCompanyId,
          page,
          size
        }
      }
    );
    return response.data;
  }
}
